<template>
    <div class="footer-content">
        <div class="content">
            <div class="title">
                <img src="../assets/logo-footer.webp" alt="logo" />
                PT DIVANA TIRTA INTERNUSA
            </div>
            <div class="btns">
                <div class="btn" v-for="btn in btns" :key="btn.name" @click="handleClick(btn.path)">
                    {{ btn.name }}
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="address">
                <img src="../assets/footer-icon1.webp" alt="" class="icon">
                builder@renovasikutech.com
            </div>
            <div class="address">
                <img src="../assets/footer-icon2.webp" alt="" class="icon">
                +6285196509880
            </div>
            <div class="address">
                <img src="../assets/footer-icon3.webp" alt="" class="icon">
                Graha Induk KUD 1st Floor <br>
                Jl. Warung Buncit Raya No. 20 <br>
                Kota Administrasi Jakarta Selatan - 12510
            </div>
        </div>
        <div class="c">
            © 2026 Hak Cipta milik PT DIVANA TIRTA INTERNUSA
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const btns = [
    {
        name: "RUMAH",
        path: "/",
    },
    {
        name: "MELAYANI",
        path: "/service",
    },
    {
        name: "MEMPERKENALKAN",
        path: "/about",
    },
    {
        name: "KONTAK",
        path: "/contact",
    },
];
const handleClick = (path) => {
    router.replace(path);
};
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 281px;
    background: #1D2846;
    padding: 0 195px;
    box-sizing: border-box;

    .content {
        width: 100%;
        padding-top: 29px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 40px;

        .title {
            width: 384px;
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 15px;
            color: #FFFFFF;
            line-height: 15px;
            margin-right: 112px;

            img {
                width: 43px;
                height: 43px;
                object-fit: contain;
                margin-right: 12px;
            }
        }

        .btns {
            display: flex;
            justify-content: space-between;
            flex: 1;

            .btn {
                font-weight: bold;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 15px;
                cursor: pointer;
            }
        }
    }

    .bottom {
        width: 45%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;

        .address {
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 18px;
            margin-bottom: 23px;

            .icon {
                width: 21px;
                height: 21px;
                object-fit: contain;
                margin-right: 24px;
            }
        }
    }

    .c {
        font-weight: 500;
        font-size: 15px;
        color: #EAEAEA;
        line-height: 24px;
        text-align: center;
    }
}
</style>